import React from 'react';
import Conversation from './Conversation.jsx';
import logo from "../../assets/horizontal-logo.png";
import { FiSearch } from 'react-icons/fi';
import { BiLogOut } from "react-icons/bi";

const Sidebar = () => {
    return (
        <div className="w-inherit relative h-full flex flex-col  items-center font-mono-sans bg-inherit rounded-r-none rounded-b-none px-10 border-r  border-teal-800 ">
            {/* Logo */}
            <div>
                <div className="flex absolute pl-8 left-0 top-0 align-middle ">
                    <img src={logo} alt="Logo" className="w-16 h-16" />
                </div>
                {/* Logout Button */}
                <div className="absolute top-0 right-0 pr-2 m-4">
                    <BiLogOut className="w-6 h-6 text-emerald-600 cursor-pointer" />
                </div>
            </div>
            {/* Search Bar */}
            <div className="flex relative  bg-teal-500 bg-opacity-20 rounded-full w-full h-fit p-5 text-slate-100 border-emerald-500 py-2 mt-20 ">
                <input type="text" placeholder="Search ..." className="flex-grow border-none bg-transparent focus:outline-none" />
                <button><FiSearch className="text-slate-300  font-thin" /></button>
            </div>
            {/* Demo Contacts */}
            <div className='w-full p-2 mt-4 mb-6 overflow-y-scroll hide-scrollbar justify-center'>
                <Conversation />
                <Conversation />
                <Conversation />
                <Conversation />
                <Conversation />
                <Conversation />
                <Conversation />
                <Conversation />
                <Conversation />
                <Conversation />

            </div>

        </div>
    );
};


export default Sidebar;